import { useEffect, useRef } from "react"
import Pusher from "pusher-js"
import { useStore } from "../ApartmentFinder/State/Store"
import zones from "./zones"
import { useAvailableApartments } from "../../components/ApartmentFinder/Utils/hooks"

const log = true

const LightsBroadcaster = () => {
  console.log("LIGHTSBROADCASTER")
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)
  const channel = useRef()
  const bedroomCounts = useStore(store => store.bedroomCounts)
  const aspects = useStore(store => store.aspects)
  const activeBlock = useStore(store => store.activeBlock)
  const activeFloor = useStore(store => store.activeFloor)
  const activeApt = useStore(store => store.activeApt)
  const favouritesActive = useStore(store => store.favouritesActive)
  const favourites = useStore(store => store.favourites)
  const apartments = useStore(store => store.apartments)
  const available = useAvailableApartments()

  const apartmentToZone = apartment => {
    /**
     * Gets the LL zone of an apartment object.
     */

    return apartment.PlotNumber.charAt(0) === "0"
      ? apartment.PlotNumber.substring(1)
      : apartment.PlotNumber
  }

  useEffect(() => {
    /**
     * Initialise the channel for talking to the lights.
     */
    const pusher = new Pusher("3cf74e9446774f909693", {
      cluster: "eu",
      authEndpoint: "https://llco-leyton-dev.ew.r.appspot.com/pusher/auth"
    })
    channel.current = pusher.subscribe("private-llco-leyton-dev")
  }, [])

  useEffect(() => {
    /**
     * Change the lights if the apartment finder mode is toggled or if the
     * filter state changes.
     */

    if (!apartments) return

    //* Not in use to turn off communal spaces when fav active
    // const alwaysOn = zones
    //   .filter(z => isNaN(parseInt(z)))
    //   .filter(z => z !== "shared" && z !== "corridor")
    if (activeApt) {
      // Turn on only those filtered in
      log && console.log("AVAIL", available)
      const onZones = available
        .map(apartmentToZone)
        .filter(z => String(Number(activeApt)) === z)
      const offZones = zones.filter(z => !onZones.includes(z))

      onZones.forEach(function (item, i) {
        if (item.charAt(0) === "0") onZones[i] = item.substring(1)
      })
      offZones.forEach(function (item, i) {
        if (item.charAt(0) === "0") offZones[i] = item.substring(1)
      })
      channel.current.trigger("client-zones-off", { zones: offZones })
      channel.current.trigger("client-zones-on", { zones: onZones })
    } else if (favouritesActive) {
      const onZones = available
        .concat(
          favourites
            .map(f => apartments.filter(a => a.PlotNumber === f)[0])
            .map(apartmentToZone)
        )
        .filter(z => zones.includes(z))
      const offZones = zones.filter(z => !onZones.includes(z))
      channel.current.trigger("client-zones-off", { zones: offZones })
      channel.current.trigger("client-zones-on", { zones: onZones })
    } else if (apartmentFinderActive && activeBlock && activeBlock.length > 1) {
      //* ALL
      // Turn on only those filtered in

      const onZones = available
        .map(apartmentToZone)
        .filter(z => zones.includes(z))

      const offZones = zones.filter(z => !onZones.includes(z))

      onZones.forEach(function (item, i) {
        if (item.charAt(0) === "0") onZones[i] = item.substring(1)
      })
      offZones.forEach(function (item, i) {
        if (item.charAt(0) === "0") offZones[i] = item.substring(1)
      })
    } else {
      // Turn on everything
      zones.forEach(function (item, i) {
        if (item.charAt(0) === "0") zones[i] = item.substring(1)
      })

      channel.current.trigger("client-zones-on", { zones })
    }
  }, [
    apartmentFinderActive,
    aspects,
    bedroomCounts,
    available,
    activeBlock,
    activeFloor,
    activeApt,
    favouritesActive,
    apartments
  ])

  return <div />
}

export default LightsBroadcaster
